import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';


@Component({
  selector: 'app-empty-table-message',
  templateUrl: './empty-table-message.component.html',
  styleUrls: ['./empty-table-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyTableMessageComponent {
  @Input() itemsCount: number = null;
  @Input() rows: any = [];
  @Input() loading: boolean;
  @Input() isBordered: boolean = true;

  public get isEmptyData(): boolean {
    if (this.itemsCount) {
      return this.itemsCount === 0;
    }

    if (this.rows instanceof MatTableDataSource) {
      return this.rows.data.length === 0;
    }

    if (Array.isArray(this.rows)) {
      return this.rows.length === 0;
    }
  }
}
